import Yup from '../../../../../helpers/custom-yup'

const schema = Yup.object().shape({
	name: Yup.string().required('Informe um nome'),
	quantity: Yup.number()
		.min(1)
		.required('Informe a quantidade'),
	description: Yup.string().required('Informe uma descrição')
})

export default schema
